/**
 * Whose portal a screen shows (frontend spec 2.2): the partner's own login,
 * or the team "viewing as" that partner, read only. Own reads stay under the
 * portal prefix; view-as reads the staff path mount with the partner id in
 * the path, never a query string.
 */
import { PARTNER_PORTALS } from "../../../lib/auth/partnerAccess.ts";
import { PORTAL_API_BASE } from "../api/partnerPortalPaths.ts";
import type { PortalScope } from "../types.ts";

const INTERNAL_API = { printer: "printers", fc: "fulfillment-centers", warehouse: "warehouses" } as const;
/** Staff view-as screens: `/printers/:id/portal/...` (and FC, warehouse in P3 / P4). */
const INTERNAL_SCREENS = { printer: "/printers", fc: "/fulfillment-centers", warehouse: "/warehouses" } as const;

export function scopeKey(scope: PortalScope): string {
  return scope.kind === "own" ? "own" : `internal:${scope.partnerId}`;
}

export function apiRoot(scope: PortalScope): string {
  if (scope.kind === "own") return PORTAL_API_BASE[scope.partner];
  return `/production/${INTERNAL_API[scope.partner]}/${encodeURIComponent(scope.partnerId)}/board`;
}

export interface PortalRoutes {
  board: string;
  schedule: string;
  order: (id: string) => string;
}

export function portalRoutes(scope: PortalScope): PortalRoutes {
  const base =
    scope.kind === "own"
      ? PARTNER_PORTALS[scope.partner].root
      : `${INTERNAL_SCREENS[scope.partner]}/${encodeURIComponent(scope.partnerId)}/portal`;
  return {
    board: `${base}/board`,
    schedule: `${base}/schedule`,
    order: (id) => `${base}/orders/${encodeURIComponent(id)}`,
  };
}
